import { Injectable } from '@angular/core';
import {isValidPesel} from '../validator/pesel-validator';

@Injectable({
  providedIn: 'root'
})
export class PeselHelperService {

  constructor() { }

  public decode(pesel: string): DecodedPesel {
    if (!isValidPesel(pesel)) {
      return { valid: false };
    }

    let year = parseInt(pesel.substring(0, 2), 10);
    let month = parseInt(pesel.substring(2, 4), 10);
    const day = parseInt(pesel.substring(4, 6), 10);

    if (month > 80) {
      year += 1800;
      month -= 80;
    } else if (month > 60) {
      year += 2200;
      month -= 60;
    } else if (month > 40) {
      year += 2100;
      month -= 40;
    } else if (month > 20) {
      year += 2000;
      month -= 20;
    } else {
      year += 1900;
    }

    // Teraz odejmujemy 1, bo JS miesiące od 0 do 11
    month -= 1;

    const birthDate = new Date(Date.UTC(year, month, day));

    const male = parseInt(pesel.substring(9, 10), 10) % 2 === 1;

    return {
      valid: true,
      male,
      female: !male,
      birthDate
    };
  }
}

export interface DecodedPesel {
  valid: boolean;
  male?: boolean;
  female?: boolean;
  birthDate?: Date;
}
